import { useInject } from '@vk-hr-tek/core/ioc';

import { useIsWidget, useSelector } from '@app/hooks';

import { AUTH_TYPES_WITHOUT_DEGRADATION_BANNER } from '../constants';
import { AuthConfigService } from '../services';
import { selectAuthInstance } from '../slice';

/**
 * Хук для проверки, можно ли показывать баннер деградации сервиса на экранах авторизации.
 * В отличие от `useAuthType` не запрашивает способ авторизации, а использует уже загруженный.
 * В виджете баннер не показывается
 * @returns `true`, если для текущего способа авторизации баннер разрешён
 */
export const useIsAuthDegradationBannerAllowed = (): boolean => {
  const config = useInject(AuthConfigService);
  const isWidget = useIsWidget();
  const authInstance = useSelector(selectAuthInstance);

  if (isWidget) {
    return false;
  }

  const localAuthType = config.getAuthType();
  const authType =
    localAuthType !== 'unknown' ? localAuthType : authInstance?.auth_type;

  return !AUTH_TYPES_WITHOUT_DEGRADATION_BANNER.includes(authType ?? '');
};
